"use client"

// src/input-context.tsx
import { createContext } from "@yamada-ui/utils";
var [InputGroupProvider, useInputGroup] = createContext({
  name: "InputGroupContext",
  errorMessage: `useInputGroup returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
});

export {
  InputGroupProvider,
  useInputGroup
};
//# sourceMappingURL=chunk-N7GDIMME.mjs.map